import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import auth from './auth'
import finantare from './finantare'
import checks from './checks'
import pages from './pages'
import companyChanged from './companyChanged'
import pageLoading from './pageLoading'
import stateAids from './stateAids'
import m3Sketch from './m3Sketch'
import notifications from './notifications'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    finantare,
    checks,
    pages,
    companyChanged,
    pageLoading,
    stateAids,
    m3Sketch,
    notifications
  },
  strict: process.env.DEV,
})
